export const isFileType = (file: any | File): file is File => {
  return file.name || file.lastModified
}
